/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VerificationDecisionDtov1 } from '../models/verification-decision-dtov-1';


/**
 * API to approve/reject provider response for verification on supplier requests
 */
@Injectable({
  providedIn: 'root',
})
export class VerificationDecisionV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation auditVerificationDecisionV1
   */
  static readonly AuditVerificationDecisionV1Path = '/v1/verifications';

  /**
   * Audit approve or reject verification response for a supplier request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `auditVerificationDecisionV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  auditVerificationDecisionV1$Response(params: {

    /**
     * Verification decision details
     */
    body: VerificationDecisionDtov1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationDecisionV1Service.AuditVerificationDecisionV1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Audit approve or reject verification response for a supplier request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `auditVerificationDecisionV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  auditVerificationDecisionV1(params: {

    /**
     * Verification decision details
     */
    body: VerificationDecisionDtov1
  },
  context?: HttpContext

): Observable<void> {

    return this.auditVerificationDecisionV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
